export default __webpack_public_path__ + "static/P_SearchThumb_InstarVision_WP-5d1cf89078cf7053982461c2c706f774.webp";